module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB2002-e53df2bc0a3ff8be36039f3c22f433d6.png";